import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EditUserDialogData {
  first_name: string;
  last_name: string;
  email: string;
  super_user: boolean;
}

export interface EditUserPayload {
  first_name: string;
  last_name: string;
  super_user: boolean;
}

@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrl: './edit-user-dialog.component.scss'
})
export class EditUserDialogComponent {
  showErrors = false;
  formData: EditUserDialogData;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: EditUserDialogData,
    private dialogRef: MatDialogRef<EditUserDialogComponent>
  ) {
    this.formData = { ...data };
  }

  isFormInvalid(): boolean {
    return !this.formData.first_name ||
      this.formData.first_name.trim().length < 2 ||
      !this.formData.last_name ||
      this.formData.last_name.trim().length < 2;
  }

  getValidationMessage(): string | null {
    if (!this.formData.first_name) {
      return 'First name must be filled out.';
    }
    if (this.formData.first_name.trim().length < 2) {
      return 'First name must be at least 2 characters.';
    }
    if (!this.formData.last_name) {
      return 'Last name must be filled out.';
    }
    if (this.formData.last_name.trim().length < 2) {
      return 'Last name must be at least 2 characters.';
    }
    return null;
  }

  submit(): void {
    this.showErrors = true;
    if (this.isFormInvalid()) {
      return;
    }
    const payload: EditUserPayload = {
      first_name: this.formData.first_name.trim(),
      last_name: this.formData.last_name.trim(),
      super_user: this.formData.super_user
    };
    this.dialogRef.close(payload);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
